/* app/js/src/components/common/image/image.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center 45%;
  background-repeat: no-repeat;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  animation: imageAppear 0.15s forwards;
}
div.loaded {
  display: block;
  background-size: cover;
  background-position: center center;
}
@keyframes imageAppear {
  from {
    -ms-transform: scale(0);
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 0;
  }
  to {
    -ms-transform: scale(1);
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
/*# sourceMappingURL=image.component.css.map */
